'use client'

import React, { createContext, useContext, useState, useEffect } from 'react'

interface TestModeContextType {
  testMode: boolean
  toggleTestMode: () => void
  setTestMode: (mode: boolean) => void
}

const TestModeContext = createContext<TestModeContextType | undefined>(undefined)

export function TestModeProvider({ children }: { children: React.ReactNode }) {
  // Initialize from localStorage if available
  const [testMode, setTestModeState] = useState<boolean>(() => {
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem('fluxpay_test_mode')
      return stored === 'true'
    }
    return false
  })

  // Persist to localStorage whenever it changes
  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('fluxpay_test_mode', String(testMode))
    }
  }, [testMode])

  const toggleTestMode = () => {
    setTestModeState((prev) => !prev)
  }

  const setTestMode = (mode: boolean) => {
    setTestModeState(mode)
  }

  return (
    <TestModeContext.Provider value={{ testMode, toggleTestMode, setTestMode }}>
      {children}
    </TestModeContext.Provider>
  )
}

export function useTestMode() {
  const context = useContext(TestModeContext)
  if (context === undefined) {
    // Return safe defaults if provider not available
    return {
      testMode: false,
      toggleTestMode: () => {},
      setTestMode: () => {},
    }
  }
  return context
}
